<template>
  <el-dialog
    width="360px"
    :title="$t('upHost.升级为主播')"
    v-bind="$attrs"
    class="dialog-dark"
    @close="onClose"
    v-on="$listeners"
  >
    <el-form
      ref="elForm"
      :model="form"
      :rules="rules"
      label-position="right"
      label-width="90px"
      class="form-dark"
      size="small"
      style="text-align: left; padding-right: 30px"
      @submit.native.prevent
    >
      <el-form-item :label="$t('upHost.主播密码')" prop="password">
        <el-input
          v-model.trim="form.password"
          :placeholder="$t('upHost.请输入')"
          show-word-limit
          @change="hostError = false"
          @keyup.native="
            form.password = form.password.replace(/[^a-zA-Z0-9]/g, '')
          "
        ></el-input>
        <div v-if="hostError" class="host-error">
          {{ $t("upHost.密码错误") }}
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="button-mini" size="mini" @click="close">{{
        $t("upHost.取消")
      }}</el-button>
      <el-button class="button-mini" type="primary" size="mini" @click="ok">{{
        $t("upHost.确定")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { beTheHost } from "@/api/liveRequest/userApi";
export default {
  name: "UpHost",
  props: {},
  data() {
    return {
      hostError: false,
      form: {
        password: "",
      },
    };
  },
  computed: {
    rules() {
      return {
        password: [
          {
            required: true,
            message: this.$t("upHost.请输入密码"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    ok() {
      this.$refs.elForm.validate((valid, object) => {
        console.log(object, "object");
        if (valid) {
          // this.upHostQuestion();
          this.submit();
        } else {
          return false;
        }
      });
    },
    //TODO 先去掉，以后用
    upHostQuestion() {
      this.$confirm(this.$t("upHost.若主播正从其本地电脑发布音视频内容"), '', {
          confirmButtonText: this.$t("controller.继续"),
          cancelButtonText: this.$t("controller.取消")
        }).then(() => {
          this.submit();
        }).catch(() => {
          this.close();        
        });
    },
    onClose() {
      this.hostError = false;
      this.$refs.elForm.resetFields();
    },
    async submit() {
      // TODO: 消息处理
      const { code } = await beTheHost(
        this.form.password,
        this.$store.getters.liveToken
      );
      if (code === 200) {
        this.$message.success(`${this.$t("upHost.您已成功升级为主播")}`);
        this.close();
      } else {
        this.hostError = true;
        // this.$message.error(msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-dark ::v-deep {
  .el-form-item:not(.is-error) {
    .el-input__inner,
    .el-textarea__inner {
      border-color: #525366;
    }
  }
}
.host-error {
  position: absolute;
  padding-top: 3px;
  line-height: 17px;
  font-size: 12px;
  color: #f56c6c;
}
</style>